var PriorityQueue = (function () {
    function PriorityQueue() {
        this._heap = [];
        this._size = 0;
    }
    Object.defineProperty(PriorityQueue.prototype, "size", {
        get: function () {
            return this._size;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PriorityQueue.prototype, "isEmpty", {
        get: function () {
            return this._size === 0;
        },
        enumerable: false,
        configurable: true
    });
    PriorityQueue.prototype.clear = function () {
        this._heap.length = 0;
        this._size = 0;
    };
    PriorityQueue.prototype.enqueue = function (item) {
        this._heap[this._size] = item;
        this._bubbleUp(this._size);
        this._size++;
    };
    PriorityQueue.prototype.dequeue = function () {
        if (this._size === 0) {
            return undefined;
        }
        var result = this._heap[0];
        this._size--;
        if (this._size > 0) {
            this._heap[0] = this._heap[this._size];
            this._bubbleDown(0);
        }
        return result;
    };
    PriorityQueue.prototype.peek = function () {
        return this._size > 0 ? this._heap[0] : undefined;
    };
    PriorityQueue.prototype._bubbleUp = function (index) {
        while (index > 0) {
            var parentIndex = Math.floor((index - 1) / 2);
            if (this._heap[index].priority >= this._heap[parentIndex].priority) {
                break;
            }
            this._swap(index, parentIndex);
            index = parentIndex;
        }
    };
    PriorityQueue.prototype._bubbleDown = function (index) {
        while (true) {
            var minIndex = index;
            var leftChild = 2 * index + 1;
            var rightChild = 2 * index + 2;
            if (leftChild < this._size &&
                this._heap[leftChild].priority < this._heap[minIndex].priority) {
                minIndex = leftChild;
            }
            if (rightChild < this._size &&
                this._heap[rightChild].priority < this._heap[minIndex].priority) {
                minIndex = rightChild;
            }
            if (minIndex === index) {
                break;
            }
            this._swap(index, minIndex);
            index = minIndex;
        }
    };
    PriorityQueue.prototype._swap = function (i, j) {
        var temp = this._heap[i];
        this._heap[i] = this._heap[j];
        this._heap[j] = temp;
    };
    return PriorityQueue;
}());
export { PriorityQueue };
